import { defineComponent as _defineComponent } from 'vue'
import {ref} from "vue";
import {useCacheStore, useWalletStore} from "@/pinia";
import {TradeOrdersDTO} from "@/shared";
import {indexTradeOrders} from "@/api/endpoints";
import {createFluxBotTransfer} from "@/api/endpoints/transfer";
import store from "@/store";
import {useAlertStore} from "@/pinia/alertStore";

//data

export default /*#__PURE__*/_defineComponent({
  __name: 'FundWithdraw',
  setup(__props) {

const open = ref<boolean>(false)
const transferAmount = ref<number>(0)
const dstWallet = ref<string>("")

// store
const cacheStore = useCacheStore();
const walletStore = useWalletStore();
const alertStore = useAlertStore();

function setTokenAmountPct(pct) {
	transferAmount.value = cacheStore.getUIAmountSOL * (1 - (pct / 100))
}


async function widthdraw(): Promise<void> {
	if (!walletStore.isConnected) return;

	const resp = await createFluxBotTransfer({
		srcWallet: walletStore.address.toString(),
		dstWallet: dstWallet.value,
		inAmount: transferAmount.value
	}).catch(e => {
		console.error("withdraw funds err", e)
		alertStore.error(e)
	})

	if (resp?.signature)
		store.commit("signatures/add_signature", {sig: resp?.signature, status: {}})
}


return { __sfc: true,open, transferAmount, dstWallet, cacheStore, walletStore, alertStore, setTokenAmountPct, widthdraw }
}

})